
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export const useAuthActions = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async (callback?: () => void) => {
    try {
      console.log("🔍 SIGN OUT: Starting sign out process");
      setIsLoading(true);
      
      const { error } = await supabase.auth.signOut();
      
      if (error) {
        console.error("🔍 SIGN OUT ERROR: Failed to sign out:", error);
        console.error("🔍 SIGN OUT ERROR DETAILS:", JSON.stringify(error));
        throw error;
      }
      
      console.log("🔍 SIGN OUT: Successfully signed out from Supabase");
      
      // Clear any sensitive data from localStorage
      localStorage.removeItem('supabase.auth.token');
      console.log("🔍 SIGN OUT: Cleared localStorage auth tokens");
      
      // If a callback was provided, execute it
      // Otherwise, navigate to login page
      if (typeof callback === 'function') {
        console.log("🔍 SIGN OUT: Executing provided callback function");
        callback();
      } else {
        console.log("🔍 SIGN OUT: Navigating to login page");
        navigate('/login');
      }
      
      // Show success message
      toast.success('Successfully signed out');
      console.log("🔍 SIGN OUT: Displayed success toast notification");
    } catch (error) {
      console.error("🔍 SIGN OUT ERROR: Exception during sign out:", error);
      console.error("🔍 SIGN OUT ERROR STACK:", error?.stack || "No stack trace available");
      toast.error('Failed to sign out. Please try again.');
      throw error; // Re-throw so the calling component can handle it if needed
    } finally {
      setIsLoading(false);
      console.log("🔍 SIGN OUT: Reset loading state");
    }
  };

  return {
    handleSignOut,
    isLoading
  };
};
